import {Injectable} from '@angular/core';
import {Race} from '../model/resources/race';
import {OfficialTeam} from '../model/resources/team';

@Injectable({
  providedIn: 'root'
})
export class ContextService {

  selectedRaceForImport?: Race;
  selectedTeamForLicenceManagement?: OfficialTeam;

  constructor() {
  }
}
